var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 2.25C1.5 1.83579 1.16421 1.5 0.75 1.5C0.335786 1.5 0 1.83579 0 2.25V21.75C0 22.1642 0.335786 22.5 0.75 22.5H23.25C23.6642 22.5 24 22.1642 24 21.75C24 21.3358 23.6642 21 23.25 21H1.5V2.25ZM12 2.25C12 1.83579 11.6642 1.5 11.25 1.5C10.8358 1.5 10.5 1.83579 10.5 2.25V17.25C10.5 17.6642 10.8358 18 11.25 18C11.6642 18 12 17.6642 12 17.25V2.25ZM20.25 3.75C20.6642 3.75 21 4.08579 21 4.5V17.25C21 17.6642 20.6642 18 20.25 18C19.8358 18 19.5 17.6642 19.5 17.25V4.5C19.5 4.08579 19.8358 3.75 20.25 3.75ZM15.75 9C16.1642 9 16.5 9.33579 16.5 9.75V17.25C16.5 17.6642 16.1642 18 15.75 18C15.3358 18 15 17.6642 15 17.25V9.75C15 9.33579 15.3358 9 15.75 9ZM6.75 13.5C7.16421 13.5 7.5 13.8358 7.5 14.25V17.25C7.5 17.6642 7.16421 18 6.75 18C6.33579 18 6 17.6642 6 17.25V14.25C6 13.8358 6.33579 13.5 6.75 13.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.07d883786605ed1f1777c757f5dba691.svg";
export { ForwardRef as ReactComponent };